import * as React from 'react';
import { SeatingOptionGroup } from '../../classes/seating-option';
import AdditionalNotes from "../../common/notes/additional-notes";
import { formatString } from '../../helpers/string-format';
import { IAppSettingsModel } from "../../reducers/fetch-settings-reducer";
import SeatingOptionGroupFilter from './seating-option-group';


interface ISeatingOptionProps {
    onToggleSeatSeparation: (evt) => any;
    onToggleAisleAccess: (evt) => any;

    additionalSeatingOptions: Array<SeatingOptionGroup>;
    renderAisleSeatToggle: boolean;
    allowAisleAccessSelected: boolean;

    removeSeatingOptionGroup: (seatingOptionGroupId: string) => void;
    selectedTicketQuantity: number;
    onAdditionalSeatRequestClear: () => void;
    onSelectSeatingOption: (seatingOptionGroupId: string, seatingOptions: Array<any>, seatingOptionToggle: boolean) => void;
    onSelectSeatingOptionQuantity: (seatingOptionGroupId: string, quantity: number) => void;
    appSettings: IAppSettingsModel;

    showComponent: boolean;
    showAdditionalNotes: boolean;
}

class SeatingOptionFilter extends React.PureComponent<ISeatingOptionProps, any>{
    constructor(props: ISeatingOptionProps) {
        super(props);
        this.state = {
            isAisleSeatRendered: props.renderAisleSeatToggle,
            checked: props.appSettings.openAdditionalSeatingOptionsOnLoad || props.additionalSeatingOptions.some(seatingOptions => seatingOptions.groupSeatSelectedQuantity > 0 || seatingOptions.groupSelected)
                || props.allowAisleAccessSelected
        };
    }
    render() {
        if (this.props.showComponent && (this.props.appSettings.renderAdditionalSeatingOptions || this.props.showAdditionalNotes)
            && (this.state.isAisleSeatRendered || this.props.additionalSeatingOptions.filter(seatingOptions => seatingOptions.showOnFiltersPage).length > 0)) {
            const defaultTicketQuantity = this.props.selectedTicketQuantity;
            const remainingSelectableTickets = defaultTicketQuantity -
                this.props.additionalSeatingOptions.map(aso => { return aso.groupSeatSelectedQuantity }).reduce((sum, n) => { return sum + n }, 0);
            const useTag = `<use xlink:href="#icon-arrow-down" />`;

            return (
                <div className="filters-section">
                    <div className="filters-section-heading">
                        <button className="btn-toggle-full" onClick={() => { this.setState({ checked: !this.state.checked }) }} aria-expanded={this.state.checked ? "true" : "false"}>
                            <h2 className="heading-general">{this.props.appSettings.filterAdditionalSeatingOptionsTitle}</h2>
                            <svg className={"filters-section-heading-toggles-icon" + (this.state.checked ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                        </button>
                        {this.props.appSettings.clearButton.length > 0 ?
                            <button className="filters-section-heading-btn" onClick={() => {
                                this.props.onAdditionalSeatRequestClear();
                            }}>{this.props.appSettings.clearButton}<span className="visually-hidden"> {this.props.appSettings.filterAdditionalSeatingOptionsTitle}</span></button>
                            : null
                        }
                    </div>

                    {this.state.checked ?
                        <div className="fade-in">
                            <div className="rich-text caption-paragraph" dangerouslySetInnerHTML={{ __html: this.props.appSettings.filterAdditionalSeatingOptionsMessage }}></div>
                            {this.state.isAisleSeatRendered ?
                                <div className="toggle-container">
                                    <input className="toggle-input" type="checkbox" checked={this.props.allowAisleAccessSelected} id="searchForAisleSeats" name="searchForAisleSeats" onChange={this.props.onToggleAisleAccess} />
                                    <label className="toggle-label" htmlFor="searchForAisleSeats"><span>{this.props.appSettings.aisleAccessSeatsLabel}</span></label>
                                </div>
                                : null}
                            {
                                this.props.additionalSeatingOptions.sort((a, b) => { return a.displayOrder - b.displayOrder }).map(seatingOptionGroup => {
                                    var selected = seatingOptionGroup.groupSeatSelectedQuantity > 0 || seatingOptionGroup.groupSelected;
                                    let unlockedSeatLimit = 0;
                                    let seatsNotMetUnlockCriteria = seatingOptionGroup.unlockSeatingOptionGroupId !== null && !this.props.additionalSeatingOptions
                                        .some(optionGroup => optionGroup.id === seatingOptionGroup.unlockSeatingOptionGroupId &&
                                            (optionGroup.groupSeatSelectedQuantity > 0 || (optionGroup.groupSelected && seatingOptionGroup.seatLimitPerUnlockSeat === 0)))

                                    if (!seatsNotMetUnlockCriteria) {
                                        const unlockSeatWithQuantity = this.props.additionalSeatingOptions
                                            .filter(optionGroup => optionGroup.id === seatingOptionGroup.unlockSeatingOptionGroupId && optionGroup.groupSeatSelectedQuantity > 0);

                                        if (unlockSeatWithQuantity.length > 0) {
                                            var unlockSeatQuantity = unlockSeatWithQuantity[0].groupSeatSelectedQuantity;
                                            unlockedSeatLimit = Math.min(unlockSeatQuantity * seatingOptionGroup.seatLimitPerUnlockSeat, seatingOptionGroup.seatLimit);
                                        }
                                    }
                                    if (!seatingOptionGroup.showOnFiltersPage) {
                                        return null;
                                    } else {
                                        return <SeatingOptionGroupFilter key={seatingOptionGroup.id} groupName={seatingOptionGroup.name} id={seatingOptionGroup.id}
                                            groupSeatSelectedQuantity={seatingOptionGroup.groupSeatSelectedQuantity} groupSeatLimitText={seatingOptionGroup.seatLimitText}
                                            groupSeatLimit={Math.min(seatingOptionGroup.seatLimit, this.props.selectedTicketQuantity)}
                                            seatingOptions={seatingOptionGroup.options}
                                            isCheckbox={seatingOptionGroup.isCheckbox}
                                            requiresSeatQuantitySelection={seatingOptionGroup.seatConditionId !== null}
                                            onSelectSeatingOptionQuantity={this.props.onSelectSeatingOptionQuantity}
                                            removeSeatingOptionGroup={this.props.removeSeatingOptionGroup} seatingOptionSubHeading={seatingOptionGroup.seatingOptionSubHeading}
                                            remainingSelectableTickets={remainingSelectableTickets} onSelectSeatingOption={this.props.onSelectSeatingOption}
                                            checked={selected}
                                            hasUnlockSeatCriteria={seatingOptionGroup.unlockSeatingOptionGroupId !== null}
                                            seatLimitPerUnlockSeat={unlockedSeatLimit}
                                            isDisabled={seatsNotMetUnlockCriteria}
                                            unlockFilterMessage={seatingOptionGroup.addSeatsToUnlockFilterMessage}
                                            maxQuantitySeatingOptionSelectedError={this.props.appSettings.maxQuantitySeatingOptionSelectedError}
                                        />
                                    }
                                })
                            }

                            {this.props.showAdditionalNotes ?
                                <AdditionalNotes />
                                : null}
                        </div> : null}
                </div>
            );
        } else {
            return null;
        }
    }

    componentWillReceiveProps(nextProps: ISeatingOptionProps) {
        this.setState({
            isAisleSeatRendered: nextProps.renderAisleSeatToggle,
            checked: nextProps.additionalSeatingOptions.some(seatingOptions => seatingOptions.groupSeatSelectedQuantity > 0)
                || nextProps.allowAisleAccessSelected ? true : this.state.checked
        });
    }

}

export default SeatingOptionFilter;